import React from "react";
import { Text } from "mineral-ui";

export const H1 = props => <Text element="h1" {...props} />;
export const H2 = props => <Text element="h2" {...props} />;
export const H3 = props => <Text element="h3" {...props} />;
export const H4 = props => <Text element="h4" {...props} />;
export const H5 = props => <Text element="h5" {...props} />;
export const H6 = props => <Text element="h6" {...props} />;
export const P = ({ small, ...props }) => (
  <Text element="p" appearance={small ? "p" : "prose"} {...props} />
);
export const Ul = props => <Text element="ul" appearance="prose" {...props} />;
export const Ol = props => <Text element="ol" appearance="prose" {...props} />;
export const Li = props => <Text element="li" {...props} />;
